/* 🤖 this file was generated by svg-to-ts*/
export const icoCaretDoubleHorizontal: {
  name: 'caret-double-horizontal';
  data: string;
} = {
  name: 'caret-double-horizontal',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 16.167V7.833C10 7.375 9.662 7 9.25 7a.71.71 0 00-.473.2l-.007-.008-4.5 4.166.008.009A.868.868 0 004 12c0 .258.112.475.277.633l-.007.009 4.5 4.166.008-.008a.71.71 0 00.472.2c.412 0 .75-.375.75-.833zm5-8.334v8.334c0 .458.338.833.75.833a.71.71 0 00.473-.2l.007.008 4.5-4.166-.008-.009A.868.868 0 0021 12a.868.868 0 00-.277-.633l.007-.009-4.5-4.166-.008.008a.71.71 0 00-.472-.2c-.412 0-.75.375-.75.833z" fill="#909090"/></svg>`
};
